import { SearchFilter } from "models/commons/search-filter"
import { i18n } from "@lingui/core"

export interface MicrojobberWrapper
{
	id: string
	firstName: string
	lastName: string
	city: string
	categories: string[]
}

export class MicrojobberRequest extends SearchFilter
{
	category: string | null = null
	city: string | null = null
	firstName: string | null = null
	lastName: string | null = null

	public static empty(): MicrojobberRequest
	{
		return new MicrojobberRequest()
	}

	public static tour3dWithCity(city: string|null): MicrojobberRequest
	{
		const request = new MicrojobberRequest()
		request.category = "TOUR_3D"
		request.city = city

		return request
	}
}

export enum MicrojobberCategoryType
{
	TOUR_3D = "TOUR_3D", //
}
class MicrojobberCategoryTypeTranslations
{
	TOUR_3D = /*i18n*/i18n._({id: "enums.microjobber-category-types.TOUR_3D", message: "Tour 3D"})
}
